module.exports = __webpack_public_path__ + "static/media/React.1a36cc4d.svg";